import { Link } from "react-router-dom";
import { Sunrise, Flame, Shield, Sparkles, Zap, Leaf, Crown } from "lucide-react";

const days = [
  { id: "mon", day: "Mon", title: "Reset", text: "Ginger + ACV wake up your gut and set the tone for the week.", icon: <Sunrise size={18} /> },
  { id: "tue", day: "Tue", title: "Ignite", text: "The ginger burn kicks in — circulation up, brain fog down.", icon: <Flame size={18} /> },
  { id: "wed", day: "Wed", title: "Defend", text: "Lemon's vitamin C stacks up right when mid-week fatigue hits.", icon: <Shield size={18} /> },
  { id: "thu", day: "Thu", title: "Glow", text: "Raw honey's antioxidants start showing — clearer skin, calmer stomach.", icon: <Sparkles size={18} /> },
  { id: "fri", day: "Fri", title: "Energize", text: "Green tea's clean lift carries you through the finish line, no crash.", icon: <Zap size={18} /> },
  { id: "sat", day: "Sat", title: "Restore", text: "Your gut is balanced — enjoy the weekend without the heaviness.", icon: <Leaf size={18} /> },
  { id: "sun", day: "Sun", title: "Own It", text: "Seven for seven. This is a ritual now — and your body knows it.", icon: <Crown size={18} /> },
];

function DayCard({ d, index }) {
  const isLast = index === days.length - 1;
  return (
    <div
      className={`ritual-day group relative flex flex-col rounded-2xl border p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${isLast ? "bg-gold text-white border-gold" : "bg-white border-gold/15 hover:border-gold/40"}`}
      style={{ animationDelay: `${index * 80}ms` }}
      data-testid={`ritual-day-${d.id}`}
    >
      <div className="flex items-center justify-between mb-3">
        <span className={`text-[11px] font-bold tracking-widest uppercase ${isLast ? "text-white/80" : "text-gold"}`}>{d.day}</span>
        <span className={`w-8 h-8 rounded-full flex items-center justify-center ${isLast ? "bg-white/20 text-white" : "bg-honey-tint text-gold"}`}>{d.icon}</span>
      </div>
      <span className={`font-playfair text-4xl font-bold leading-none mb-1 ${isLast ? "text-white/40" : "text-gold/25"}`}>{index + 1}</span>
      <h3 className={`font-playfair text-lg font-bold mb-1 ${isLast ? "text-white" : "text-brown-dark"}`}>{d.title}</h3>
      <p className={`text-xs leading-relaxed ${isLast ? "text-white/85" : "text-gray-500"}`}>{d.text}</p>
    </div>
  );
}

export default function WeeklyRitualStrip() {
  return (
    <section className="py-16 md:py-24 px-6 bg-cream-light overflow-hidden" data-testid="weekly-ritual-section">
      <div className="max-w-7xl mx-auto">
        <div className="md:flex md:items-end md:justify-between gap-10 mb-10">
          <div className="max-w-xl">
            <p className="text-xs font-bold tracking-widest text-gold uppercase mb-3">The Weekly Ritual</p>
            <h2 className="font-playfair text-3xl md:text-5xl font-bold text-brown-dark mb-4" data-testid="weekly-ritual-title">7 Days. 7 Shots. One New You.</h2>
            <p className="text-gray-500 text-sm md:text-base leading-relaxed">
              Wellness isn't a one-time fix — it's what you do every morning. Every 7-Pack is built for exactly one week, so you never miss a day and never run out mid-ritual.
            </p>
          </div>
          <Link to="/shop" className="btn-gold mt-6 md:mt-0 flex-shrink-0" data-testid="weekly-ritual-cta">Start Your Week</Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {days.map((d, i) => <DayCard key={d.id} d={d} index={i} />)}
        </div>
        <p className="text-center text-xs text-gray-400 mt-8" data-testid="weekly-ritual-footnote">
          One shot each morning · Subscribe &amp; Save, and your next week arrives before this one ends.
        </p>
      </div>
    </section>
  );
}
